exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/field/checkbox/checkbox.component.scss
// module id = ../../../../../src/app/thought-module/field/checkbox/checkbox.component.scss
// module chunks = main